import client from "graphql/client";
import { loader } from "graphql.macro";
import { ENVIRONMENT } from "constants/environment";
import { VIDEODESCRIPTIONS_UPDATE } from "../types";

const updateVideoDescriptionMutation = loader("../../graphql/mutations/videoDescriptionSet.graphql");
const signUploadUrlMutation = loader("../../shared/graphql/mutations/files/signUploadUrl.graphql");
const fileUploadedMutation = loader("../../shared/graphql/mutations/files/fileUploaded.graphql");

const PRODUCTION_ORGANISATION_ID = "67c175e61b8eba64819ea8ed";
const NON_PRODUCTION_ORGANISATION_ID = "5cc321296d78325296efdea7";

const uploadVideoToS3 = async (videoFile, organisationId) => {
    const signResponse = await client.mutate({
        mutation: signUploadUrlMutation,
        variables: {
            originalFilename: videoFile.name,
            fileType: videoFile.type || "video/mp4",
            organisationId
        }
    });

    const uploadPayload = signResponse?.data?.signUploadUrl;
    if (!uploadPayload?.signedUrl || !uploadPayload?.filename) {
        throw new Error("Unable to get signed upload URL for video.");
    }

    const uploadHeaders = new Headers();
    uploadHeaders.append("Content-Type", videoFile.type || "video/mp4");

    if (uploadPayload.cacheControl) {
        uploadHeaders.append("Cache-Control", uploadPayload.cacheControl);
    }

    if (uploadPayload.serverSideEncryption) {
        uploadHeaders.append("x-amz-server-side-encryption", uploadPayload.serverSideEncryption);
    }

    const uploadResponse = await fetch(uploadPayload.signedUrl, {
        method: "PUT",
        mode: "cors",
        headers: uploadHeaders,
        body: videoFile
    });

    if (!uploadResponse.ok) {
        throw new Error(`S3 upload failed with status ${uploadResponse.status}`);
    }

    await client.mutate({
        mutation: fileUploadedMutation,
        variables: {
            filename: uploadPayload.filename,
            label: "video-description",
            organisationId
        }
    });

    return uploadPayload.signedUrl.split("?")[0];
};

export const updateVideoDescriptionAction = (updatedVideoDescription, videoFile) => async (dispatch) => {
    try {
        const organisationId = ENVIRONMENT === "production" ?
            PRODUCTION_ORGANISATION_ID :
            NON_PRODUCTION_ORGANISATION_ID;

        let videoUrl = updatedVideoDescription.videoUrl;
        if (videoFile) {
            if (!organisationId) {
                throw new Error("Missing organisationId required for video upload.");
            }

            videoUrl = await uploadVideoToS3(videoFile, organisationId);
        }

        const response = await client.mutate({
            mutation: updateVideoDescriptionMutation,
            variables: {
                input: {
                    id: updatedVideoDescription.id,
                    title: updatedVideoDescription.title,
                    description: updatedVideoDescription.description,
                    published: !!updatedVideoDescription.published,
                    videoUrl
                },
                video: null
            }
        });

        const persistedVideoDescription = response?.data?.videoDescriptionSet || {
            ...updatedVideoDescription,
            videoUrl
        };

        dispatch({
            type: VIDEODESCRIPTIONS_UPDATE,
            updatedVideoDescription: persistedVideoDescription
        });
    } catch (error) {
        console.error("Error saving video description:", error);
    }
};
